import { CircularProgress } from "@material-ui/core";
import { Grid, GridColumn as Column } from "@progress/kendo-react-grid";
import React, { Component } from "react";
import { toastr } from "react-redux-toastr";
import Api from "../../Services/Api";
import "../../Styles/Impacts.scss";
import { Popup } from "@progress/kendo-react-popup";

export default class ProbabilityRange extends Component {
  constructor(props) {
    super(props);
    this.state = {
      rangeList: [],
      probabilityColumns: [],
      dynamicHeatmapProbabilityRange: [],
      currentChangedValue: {},
      loader: false,
      heatMapCount:"",
      ProbabilityRange:[],
      isimpactconfiguration:false,
      probability_value: "",
    };
  }
  componentDidMount() {
    this.getProbabilityRangeList();
  }

  getProbabilityRangeList = async () => {
    try {
      this.setState({ ...this.state, loader: true });
      let response = await Api.GetProbabilityRange();
      if (response.status === 200) {
        this.setState({ProbabilityRange:response.dynamicHeatmapProbabilityRange,
          heatMapCount: response.heatmapCount,
        })
        let arr = response.dynamicHeatmapProbabilityRange;
        let rangeArray = [];
        let probabilityObj = {};

        arr = arr?.map((item) => {
          item[item.probabilityDescription] = item.probabilityRangeValue;          probabilityObj = { ...probabilityObj, ...item };
          return item;
        });
        rangeArray = arr.map((column, index) => (
          <Column
            key={index}
            field={column.probabilityDescription}
            title={column.probabilityDescription + " From (%)"}
            editor="numeric"
            width="110px"
            format="{0:##,#}"
            editable={index === 0 ? false : true}
          />
        ));
        this.setState({
          loader: false,
          dynamicHeatmapProbabilityRange:
            response.dynamicHeatmapProbabilityRange,
          rangeList: [probabilityObj],
          probabilityColumns: rangeArray,
        });
      } else {
        this.setState({
          loader: false,
          rangeList: [],
          dynamicHeatmapProbabilityRange: [],
        });
      }
    } catch (error) {
      console.error(error);
      this.setState({ ...this.state, loader: false });
    }
  };

  cellRender = (tdElement, cellProps) => {
    const dataItem = cellProps.dataItem;
    const cellField = cellProps.field;
    const inEditField = dataItem["inEdit"];

    const additionalProps =
      cellField && cellField === inEditField
        ? {
            ref: (td) => {
              const input = td && td.querySelector("input");
              const activeElement = document.activeElement;

              if (
                !input ||
                !activeElement ||
                input === activeElement ||
                !activeElement.contains(input)
              ) {
                return;
              }

              if (input.type === "checkbox") {
                input.focus();
              } else {
                input.select();
              }
            },
          }
        : {
            onClick: () => {
              this.enterEdit(dataItem, cellField);
            },
          };
    if (tdElement && tdElement.props) {
      return React.cloneElement(
        tdElement,
        { ...tdElement.props, ...additionalProps },
        tdElement.props.children
      );
    } else {
      return <td></td>;
    }
  };

  rowRender = (trElement) => {
    const trProps = {
      ...trElement.props,
      onMouseDown: (event) => {
        event.preventExit = true;
        clearTimeout(event.preventExitTimeout);
        event.preventExitTimeout = setTimeout(() => {
          event.preventExit = undefined;
        });
      },
      onBlur: (event) => {
        clearTimeout(event.blurTimeout);
        if (!event.preventExit) {
          event.blurTimeout = setTimeout(() => {
            this.exitEdit();
          });
        }
        if (
          this.state.editField != "expanded" &&
          this.state.currentChangedValue
        ) {
          this.updateRecord(this.state.currentChangedValue);
        }
      },
      onFocus: (event) => {
        clearTimeout(event.blurTimeout);
      },
    };
    return React.cloneElement(
      trElement,
      { ...trProps },
      trElement.props.children
    );
  };

  enterEdit = (dataItem, field) => {
    const dataValue = this.state.rangeList.map((item) => ({
      ...item,
      inEdit: item.id === dataItem.id ? field : undefined,
    }));
    this.setState({
      rangeList: dataValue,
      currentChangedValue: dataItem,
    });
  };

  exitEdit = () => {
    const dataValue = this.state.rangeList.map((item) => ({
      ...item,
      inEdit: undefined,
    }));
    this.setState({
      rangeList: dataValue,
    });
  };

  isValidateThresholdRange = (dataItem) => {
    if (dataItem.veryLowRangeValue != 0) {
      toastr.error("Very low range value should be equal to 0");
      return true;
    } else if (dataItem.veryLowRangeValue >= dataItem.lowRangeValue) {
      toastr.error(
        "Low range value should be greater than very low range value"
      );
      return true;
    } else if (dataItem.lowRangeValue >= dataItem.mediumRangeValue) {
      toastr.error("Medium range value should be greater than low range value");
      return true;
    } else if (dataItem.mediumRangeValue >= dataItem.highRangeValue) {
      toastr.error(
        "High range value should be greater than medium range value"
      );
      return true;
    } else if (dataItem.highRangeValue >= dataItem.veryHighRangeValue) {
      toastr.error(
        "Very high range value should be greater than high range value"
      );
      return true;
    } else if (dataItem.veryHighRangeValue > 99) {
      toastr.error("Very high range value should not greater than 99");
      return true;
    }
  };
  getOrderId = (field) => {
    let obj = this.state.dynamicHeatmapProbabilityRange.find(
      (item) => item.probabilityDescription === field
    );
    return obj?.orderId;
  };
  getAbbreviation = (field) => {
    let obj = this.state.dynamicHeatmapProbabilityRange.find(
      (item) => item.fullDescription === field
    );
    return obj?.abbreviation;
  };
  getAbbreviationByOrderId = (orderId) => {
    let obj = this.state.dynamicHeatmapProbabilityRange.find(
      (item) => item.orderId === orderId
    );
    return obj?.abbreviation || "NA";
  };
  getprobailitydescription = (field) => {
    let obj = this.state.dynamicHeatmapProbabilityRange.find(
      (item) => item.probabilityDescription === field
    );
    return obj?.probabilityDescription;
  };
  updateRecord = async (dataItem) => {
    try {
      // if(this.isValidateThresholdRange(dataItem)){
      //   this.getProbabilityRangeList();
      //   return;
      // }
      delete dataItem["orderId"];
      delete dataItem["abbreviation"];
      delete dataItem["fullDescription"];
      delete dataItem["inEdit"];
      delete dataItem["value"];
      delete dataItem["probabilityRangeValue"];
      delete dataItem["probabilityDescription"];

      this.setState({ ...this.state, loader: true });
      let arr = [];
      var i = 1;
      for (let [key, value] of Object.entries(dataItem)) {
        // console.log(key, value);
        arr.push({
          OrderId: this.getOrderId(key),
          fullDescription: key,
          abbreviation: this.getAbbreviation(key),
          ProbabilityDescription: key,
          probabilityRangeValue: value,
        });
        i++;
      }
      let errortoaster = this.impactvalidation(arr);
      if (errortoaster === true) {
        this.setState({ ...this.state, loader: false });
        toastr.error(
          "Entered value should be between the values entered in lower range and in the higher range"
        );
        return;
      }
      var request = {
        ProbabilityRangeLabel: arr,
      };
      let response = await Api.UpdateProbabilityRange(request);
      if (response.status === 200) {
        this.setState({ ...this.state, loader: false });
        toastr.success(response.message);
        this.getProbabilityRangeList();
      } else {
        toastr.error(response.message);
        this.setState({ ...this.state, loader: false });
      }
    } catch (error) {
      console.error(error);
      this.setState({ ...this.state, loader: false });
    }
  };

  itemChange = (event) => {
    const changedValue = { ...event.dataItem, [event.field]: event.value };
    const dataValue = this.state.rangeList.map((item) =>
      item.id === event.dataItem.id
        ? { ...item, [event.field]: event.value }
        : item
    );
    this.setState({
      ...this.state,
      currentChangedValue: changedValue,
      rangeList: dataValue,
    });
  };

  impactvalidation = (impactThresholdValue) => {
    let errortoaster = false;
    for (var i = 0; i < impactThresholdValue.length - 1; i++) {
      if (
        impactThresholdValue[i].probabilityRangeValue >=
        impactThresholdValue[i + 1].probabilityRangeValue
      ) {
        errortoaster = true;
        return errortoaster;
      }
    }
    return errortoaster;
  };
  handleimpactConfiguration = () => {
    this.setState({
      isimpactconfiguration: !this.state.isimpactconfiguration,
    });
  };
  closeimpactconfigration = () => {
    if (this.state.isimpactconfiguration) {
      this.setState({
        isimpactconfiguration: false,
      });
    }
  };
  updaterangeconfiguration = async () => {
    for (var i = 0; i < this.state.heatMapCount; i++) {
      if (
        !this.state.ProbabilityRange[i]?.probabilityDescription ||
        this.state.ProbabilityRange[i]?.probabilityDescription == "" ||
        this.state.ProbabilityRange[i]?.probabilityDescription === null ||
        this.state.ProbabilityRange[i]?.probabilityDescription == undefined
      ) {
        toastr.error("Full Description is Required");
        return;
      }
    }
    let probabilityDescription = this.state.ProbabilityRange.map((e) =>
      e.probabilityDescription.toLowerCase()
    );
    probabilityDescription = probabilityDescription.map(function (str) {
      return str.replaceAll(/\s/g, "");
    });
    const temp = new Set(probabilityDescription);
    let result = temp.size !== probabilityDescription.length;
    if (result === true) {
      toastr.error("Full Description value already exist");
    }
    let arr = [];
    this.state.ProbabilityRange.map((item, index) => {
      arr.push({
        OrderId: item.orderId,
        fullDescription: item.fullDescription,
        abbreviation: this.getAbbreviationByOrderId(item.orderId),
        ProbabilityDescription: item.probabilityDescription,
        probabilityRangeValue: item.probabilityRangeValue,
      });
    });
    const request = {
      ProbabilityRangeLabel: arr,
    };
    let response = await Api.UpdateProbabilityRange(request);

    if (response.status === 200) {
      if (result === false) {
        toastr.success(response.message);
        this.closeimpactconfigration();
        this.getProbabilityRangeList();
      }
    } else {
      toastr.error(response.message);
    }
  };
  getprobabilityDescription = (i) => {
    let obj = this.state.ProbabilityRange[i];
    return obj?.probabilityDescription;
  };
  handleprobabilityDescription = (e, i) => {
    try {
      let probabiltyArray = this.state.ProbabilityRange.map(
        (item, index) => {
          if (index === i) {
            item["probabilityDescription"] = e.target.value?.trim();
          }
          return item;
        }
      );
      this.setState({ ProbabilityRange: probabiltyArray });
    } catch (err) {
      console.log(err);
    }
  };
  getDynamicMatrix = () => {
    let matrixfields = [];
    for (let i = 0; i < this.state.heatMapCount; i++) {
      let value = false;
      let z = i + 1;
      if (z % 2 == 0) {
        value = true;
        console.log("value", value);
      }
      matrixfields.push(
        <div
          className="admin-probability-field"
          style={{
            marginLeft: value ? "40px" : "60px",
            float: value ? "right" : "left",
          }}
        >
          <label>
            Full Description {i + 1}
            <span style={{ color: "#e76767" }}>*</span>
          </label>
          <input
            type="text"
            name="Label"
            className="form-control"
            autocomplete="off"
            value={this.getprobabilityDescription(i)}
            onChange={(e) => this.handleprobabilityDescription(e, i)}
            style={{ marginRight: value ? "40px" : null }}
          />
        </div>
      );
    }
    return matrixfields;
  };
  render() {
    return (
      <div className="impactsContainer">
        {this.state.loader ? (
          <span className="MatTableSpinner">
            <CircularProgress style={{ color: "#FFFFFF" }} size={70} />
          </span>
        ) : null}

        <div className="impactsTableCont">
          <div className="impactsHeader">
            <h4>Heatmap Probability Range</h4>
            <div
              className="probabilityconfigurationbtn"
              onClick={this.handleimpactConfiguration}
            >
              Range Definition
            </div>
          </div>
          <div className="dataGrids">
            <Grid
              data={this.state.rangeList}
              resizable
              cellRender={this.cellRender}
              rowRender={this.rowRender}
              editField="inEdit"
              onItemChange={this.itemChange}
            >
              {this.state.probabilityColumns}
            </Grid>
          </div>
          <Popup
           show={this.state.isimpactconfiguration}
           popupClass={"popup-content"}
         >
             <div className="probabilityconfiguration">
              <label>Range Definition</label>

              <p>
                Note: Range names must be entered in increasing order of
                severity i.e. Lowest to Highest. For example, if the selection
                is 3 x 3 and the range names are Low, Medium and High, Full
                Description 1 must be Low, Full Description 2 must be Medium and
                Full Description 3 must be High.
              </p>
              <div className="impactdynamix_fields" >
                {this.getDynamicMatrix()}
              </div>
              <div className="impact_btn">
                <div
                  className="imp_update"
                  onClick={this.updaterangeconfiguration}
                >
                  UPDATE
                </div>
                <div
                  className="imp_cancel"
                  onClick={this.closeimpactconfigration}
                >
                  CANCEL
                </div>
              </div>
            </div>
          </Popup>
        </div>
      </div>
    );
  }
}
